import React from 'react'
import styled from "styled-components";

const Circle = styled.div`
	--_size: 275px;
	--_color: #55b9a3;
	--_offset: 0;

	position: absolute;

	width: calc(var(--_size) * 2);
	height: calc(var(--_size) * 2);

	background-image: radial-gradient(var(--_color) 0%, transparent 70%);
	filter: blur(calc(var(--_size) * 0.35));
	opacity: 0.5;

	&.left {
		left: var(--_offset);
	}

	&.right {
		right: var(--_offset);
	}
`

const Container = styled.div`
	position: relative;
	z-index: -1;

	width: calc(100% - 2rem);
	margin-inline: auto;

	@media (min-width: 576px) {
		max-width: 540px;
	}

	@media (min-width: 768px) {
		max-width: 720px;
	}

	@media (min-width: 992px) {
		max-width: 960px;
	}

	@media screen and (min-width: 1200px) {
		max-width: 1170px;
	}
`

const px = val => val ? `${val}px` : undefined;
const percent = val => val ? `${val}%` : undefined;

/**
 * @param {?number} size
 * @param {?number} top
 * @param {?string} color
 * @param {?number} offset
 * @constructor
 */
export function BlurredCircleLeft({ size, top, color, offset }){
  return <Circle className="left" style={{
    '--_size': px(size),
    '--_color': color,
    '--_offset': percent(offset),
    top: px(top)
  }} />
}

/**
 * @param {?number} size
 * @param {?number} top
 * @param {?string} color
 * @param {?number} offset
 * @constructor
 */
export function BlurredCircleRight({ size, top, color, offset }){
  return <Circle className="right" style={{
    '--_size': px(size),
    '--_color': color,
    '--_offset': percent(offset),
    top: px(top)
  }} />
}

export function BlurredCircleContainer({ children }){
  return <Container className="container" aria-hidden="true">{children}</Container>
}